module.exports = __webpack_public_path__ + "img/graph-preview.de0f97b3.png";